import BadgerAccordion from 'badger-accordion';
import { detectMobileUntilTablet } from "../../../js/utils";

export default class ContentAccordion {
  constructor(
    elementSelector = '.js-swa-content-accordion',
    headerClass = '.js-swa-content-accordion__headline-title',
    panelClass = '.js-swa-content-accordion-panel',
    panelInnerClass = '.js-swa-content-accordion-panel-inner',
    activeClass = 'swa-content-accordion-is-active',
    hiddenClass = 'swa-content-accordion-is-hidden',
    initializedClass = 'swa-content-accordion--initialized',
    headerDataAttr = 'data-swa-content-accordion-header-id'
  ) {
    this.elementSelector = elementSelector;
    this.headerClass = headerClass;
    this.panelClass = panelClass;
    this.panelInnerClass = panelInnerClass;
    this.activeClass = activeClass;
    this.hiddenClass = hiddenClass;
    this.initializedClass = initializedClass;
    this.headerDataAttr = headerDataAttr;
    this.headerItemContent = '.swa-content-accordion__headline-title-content';
  }

  addBoldClassToClickedEntryTitle(defaultClass, boldClass) {
    let contentAccordions = document.querySelectorAll('.js-swa-content-accordion');
    contentAccordions.forEach(contentAccordion => {
      //select all title wrappers nodes
      let accordionItemsHeaders = contentAccordion.querySelectorAll(this.headerClass);
      accordionItemsHeaders.forEach(accordionItemHeader => {
        //for each title wrapper select it's title content on which we want to add/remove classes
        let accordionItemHeaderContent = accordionItemHeader.querySelector(this.headerItemContent);
        accordionItemHeader.addEventListener('click', (e) => {

          if (!contentAccordion.classList.contains('js-swa-content-accordion-wrapper--no-bolding-headlines')) {
            //check if PDP page in order to use a different font class
            if (contentAccordion.classList.contains('js-swa-content-accordion-product-detail')) {
              defaultClass = 'swa-label-sans--medium';
              boldClass = 'swa-label-sans--medium-strong';
            } else {
              defaultClass = 'swa-label-sans--default';
              boldClass = 'swa-label-sans--default-strong';
            }

            if (accordionItemHeader.classList.contains('swa-content-accordion-is-active')) {
              //at click, before adding bold class to the clicked title wrapper, remove that class from the other title elements of that accordion
              contentAccordion.querySelectorAll('.swa-content-accordion__headline-title-content').forEach(unselectedHeaderElement => {
                unselectedHeaderElement.classList.remove(boldClass);
                unselectedHeaderElement.classList.add(defaultClass);
              });
              accordionItemHeaderContent.classList.remove(defaultClass);
              accordionItemHeaderContent.classList.add(boldClass);
            } else {
              accordionItemHeaderContent.classList.remove(boldClass);
              accordionItemHeaderContent.classList.add(defaultClass);
            }
          }

          // the following lines are for updating the URL after clicking on any accordion element
          let targetAccordionID = e.target.closest('.swa-content-accordion__headline').getAttribute('id');
          if (targetAccordionID) {
            let myURL = new URL(location.href);
            // set the new URL based on the accordionID (that was clicked)
            myURL.searchParams.set("accordionID", targetAccordionID);
            window.history.pushState(null, '', myURL);
          }
        });
      });
    });
  }

  scrollToActiveEntry() {
    let accordionItemsHeaders = document.querySelectorAll(this.headerClass);
    accordionItemsHeaders.forEach(accordionItemHeader => {
      accordionItemHeader.addEventListener('click', () => {
        setTimeout(() => {
          if (accordionItemHeader.classList.contains('swa-content-accordion-is-active')) {
            let scrollSize = accordionItemHeader.offsetTop - 53; //calculate distance until top, including the height of the sticky header
            window.scrollTo({ top: scrollSize, behavior: 'smooth' });
          }
        }, 600); // scroll must occur only after all the transitions are finished
      });
    });
  }

  // Used for Deeplink - SWANSL-28976
  findParameter(parameterName) {
    var result = null;
    var temporaryArray = [];

    // remove the '?' by doing the substr() and then we split after each '&'
    location.search.substr(1).split("&").forEach(function (item) {
      temporaryArray = item.split("=");

      // after splitting again ('='), we want the first one to be equal to "accordionID"
      if (temporaryArray[0] === parameterName) {
        result = decodeURIComponent(temporaryArray[1]);
      }
    });
    // the result comes without #, therefore we add it manually here in order to have an ID
    result = "#" + result
    return result;
  }

  triggerClickURL() {
    const accordionID = "accordionID"; // DO NOT Change this parameter unless is requested (if this is changed, please change searchParams.set above as well)
    const accordionObject = document.querySelector(this.findParameter(accordionID));

    if (accordionObject) {
      // trigger the click on the first child of the object selected by ID
      const accordionObjectFirstChild = accordionObject.children[0];
      accordionObjectFirstChild.click();

      // scroll must occur only after all the transitions are finished
      setTimeout(() => {
        let scrollSize = accordionObject.offsetTop - 53; // calculate distance until top, including the height of the sticky header
        window.scrollTo({ top: scrollSize, behavior: 'smooth' });
      }, 600)
    }
  }

  preOpened() {
    return !!document.querySelector('.swa-content-accordion__panel--preopened')
  }

  init() {

    const contentAccordionElements = document.querySelectorAll(this.elementSelector);
    if (!contentAccordionElements) {
      return;
    }

    //define font class variables:
    let defaultClass = '';
    let boldClass = '';

    let contentAccordionArray = [];

    // Create a new instance of the accordion/accordions
    if (this.preOpened()) {
      Array.from(contentAccordionElements).forEach((contentAccordionElement) => {
        contentAccordionArray.push(
          this.accordion = new BadgerAccordion(contentAccordionElement, {
            headerClass: this.headerClass,
            panelClass: this.panelClass,
            panelInnerClass: this.panelInnerClass,
            activeClass: this.activeClass,
            hiddenClass: this.hiddenClass,
            initializedClass: this.initializedClass,
            headerDataAttr: this.headerDataAttr,
            openHeadersOnLoad: [0],
            roles: {
              region: true
            }
          })
        );

        //check if PDP page in order to use a different font class
        if (contentAccordionElement.classList.contains('js-swa-content-accordion-product-detail')) {
          defaultClass = 'swa-label-sans--medium';
          boldClass = 'swa-label-sans--medium-strong';
        } else {
          defaultClass = 'swa-label-sans--default';
          boldClass = 'swa-label-sans--default-strong';
        }
      });

      // Add bold class to the first title of the first accordion
      const firstAccordionTitle = document.querySelector('.swa-content-accordion-is-active .swa-content-accordion__headline-title-content');

      if (!!firstAccordionTitle) {
        firstAccordionTitle.classList.add(boldClass);
        firstAccordionTitle.classList.remove(defaultClass);
      }

    } else {
      Array.from(contentAccordionElements).forEach((contentAccordionElement) => {
        contentAccordionArray.push(
          this.accordion = new BadgerAccordion(contentAccordionElement, {
            headerClass: this.headerClass,
            panelClass: this.panelClass,
            panelInnerClass: this.panelInnerClass,
            activeClass: this.activeClass,
            hiddenClass: this.hiddenClass,
            initializedClass: this.initializedClass,
            headerDataAttr: this.headerDataAttr
          })
        );
      });
    }


    // At resize, Badger Accordion must recalculate the max height of each content container of each entry
    window.addEventListener('resize', () =>
      contentAccordionArray.forEach(accordion => {
        accordion.calculateAllPanelsHeight();
      })
    );

    // Scroll to new active accordion on mobile
    if (detectMobileUntilTablet()) {
      this.scrollToActiveEntry();
    }

    this.addBoldClassToClickedEntryTitle();
    this.triggerClickURL();
  }
}
